import { COLORS } from "styles/colors";

export const themeOverrides = {
  MuiButton: {
    root: {
      borderRadius: "6px",
      paddingLeft: "12px",
      paddingRight: "12px",
    },
    contained: {
      backgroundColor: COLORS.COLOR_000000,
      color: COLORS.COLOR_FFFFFF,
    },
    outlined: {
      cursor: "pointer",
      minWidth: "180px",
      width: "100%",
      borderColor: "transparent",
      color: COLORS.COLOR_000000,
    },
  },
};
